import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

const fetcher = async (url) => {
  const { data } = await apiClient.get(url);
  if (!data.success) {
    throw new Error(data.message || 'Failed to fetch data');
  }
  return data.data;
};

const singleItemFetcher = async (url) => {
  const data = await fetcher(url);
  return data && data.length > 0 ? data[0] : null;
};

export const useAboutMe = () => {
  return useQuery({
    queryKey: ['aboutMe'],
    queryFn: () => singleItemFetcher('/about-me'),
  });
};

export const usePersonalInfo = () => {
  return useQuery({
    queryKey: ['personalInfo'],
    queryFn: () => singleItemFetcher('/personal-info'),
  });
};

export const useSocialLinks = () => {
  return useQuery({
    queryKey: ['socialLinks'],
    queryFn: () => fetcher('/social-links'),
  });
};

export const useBlogs = () => {
  return useQuery({
    queryKey: ['blogs'],
    queryFn: () => fetcher('/blogs'),
  });
};

export const useExpertise = () => {
  return useQuery({
    queryKey: ['expertise'],
    queryFn: () => fetcher('/expertise'),
  });
};

export const useSkills = () => {
  return useQuery({
    queryKey: ['skills'],
    queryFn: () => fetcher('/skills'),
  });
};

export const useEducation = () => {
  return useQuery({
    queryKey: ['education'],
    queryFn: () => fetcher('/education'),
  });
};

export const useExperiences = () => {
  return useQuery({
    queryKey: ['experiences'],
    queryFn: () => fetcher('/experiences'),
  });
};

export const useCertifications = () => {
  return useQuery({
    queryKey: ['certifications'],
    queryFn: () => fetcher('/certifications'),
  });
};

export const useInterests = () => {
  return useQuery({
    queryKey: ['interests'],
    queryFn: () => fetcher('/interests'),
  });
};

export const useTestimonials = () => {
  return useQuery({
    queryKey: ['testimonials'],
    queryFn: () => fetcher('/testimonials'),
  });
};

export const useAchievements = () => {
  return useQuery({
    queryKey: ['achievements'],
    queryFn: () => fetcher('/achievements'),
  });
};

export const useSiteSettings = () => {
  return useQuery({
    queryKey: ['siteSettings'],
    queryFn: () => singleItemFetcher('/site-settings'),
  });
};
